import axios from 'axios';
import type { BigNumberish } from 'ethers';

export interface Asset {
  name: string;
  description: string;
  imageUrl: string;
  imagePreviewUrl: string | null;
  imageThumbnailUrl: string | null;
  imageOriginalUrl: string | null;
  animationUrl: string | null;
  animationOriginalUrl: string | null;
  owner: {
    username: string;
    profileImgUrl: string;
    address: string;
  };
}

interface OpenSeaAssetResponse {
  name: string;
  description: string;
  image_url: string;
  image_preview_url: string;
  image_thumbnail_url: string;
  image_original_url: string;
  animation_url: string;
  animation_original_url: string;
  creator: {
    user: {
      username: string;
    };
    profile_img_url: string;
    address: string;
  };
}

export const getMetadata = async (
  tokenAddress: string,
  tokenId: BigNumberish,
  currentNetwork: string,
) => {
  const subDomain =
    !currentNetwork || currentNetwork === 'MAINNET' ? 'api' : 'testnets-api';
  const { data } = await axios.get<OpenSeaAssetResponse>(
    `https://${subDomain}.opensea.io/api/v1/asset/${tokenAddress}/${tokenId.toLocaleString()}`,
    { headers: { 'X-API-KEY': 'e287766241ce4894bd347c65f35be2e7' } },
  );

  const asset: Asset = {
    name: data.name,
    description: data.description,
    imageUrl: data.image_url,
    imagePreviewUrl: data.image_preview_url,
    imageThumbnailUrl: data.image_thumbnail_url,
    imageOriginalUrl: data.image_original_url,
    animationUrl: data.animation_url,
    animationOriginalUrl: data.animation_original_url,
    owner: {
      username: data.creator.user.username,
      profileImgUrl: data.creator.profile_img_url,
      address: data.creator.address,
    },
  };

  return asset;
};
